import * as yup from 'yup';

export const quoteVersionReleaseSchema = () =>
  yup.object().shape({
    attachPdf: yup.boolean().nullable(),
    attachCls: yup.boolean().nullable(),
    note: yup.string().nullable(),
  });
